import React from "react";
import { Switch, Route } from "react-router-dom";


import { PracticesDebtsProvider } from "../contexts/practices-debts-context";
import { CustomerProvider } from "../contexts/customer-context";
import { BanksProvider } from "../contexts/banks-context";
import { CommentsProvider } from "../contexts/comments-context";
import { UserProvider } from "../contexts/user-context";
import { ServiceCustomerProvider } from "../contexts/service-customer-context";
import { ServiceProvider } from "../contexts/service-context";
import { FilesProvider } from "../contexts/files-context";
import ListPracticesFinanthia from "../components/practices-finanthia/list-practices-finanthia/list-practices-finanthia";

const PracticesFinanthia = ({ match }) => {
  return (
    <div className="practices-finanthia">
      <PracticesDebtsProvider>
        <CustomerProvider>
          <CommentsProvider>
            <BanksProvider>
              <UserProvider>
                <ServiceCustomerProvider>
                  <ServiceProvider>
                    <FilesProvider>
                      <Switch>
                        <Route
                          exact
                          path={`${match.path}`}
                          component={ListPracticesFinanthia}
                        />
                      </Switch>
                    </FilesProvider>
                  </ServiceProvider>
                </ServiceCustomerProvider>
              </UserProvider>
            </BanksProvider>
          </CommentsProvider>
        </CustomerProvider>
      </PracticesDebtsProvider>
    </div>
  );
};

export default PracticesFinanthia;
